import styled from '@emotion/styled';

export const RadioContainer = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;

export const RadioItem = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1rem;
	border-radius: 0.4rem;
	cursor: pointer;
	transition: all 0.2s ease;
`;

export const NewAccountTypeArea = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;
